import type {BuildId, TestOccurrenceId} from '../../../../types'

export enum TestTab {
  CURRENT_FAILURE = 'currentFailure',
  FIRST_FAILURE = 'firstFailure',
  NEXT_FIXED = 'nextFixed',
}

export type Props = {
  className?: string
  buildId: BuildId
  testOccurrenceId?: TestOccurrenceId
}
